module.exports = __webpack_public_path__ + "img/equipment_bg.2efcc5fa.png";